var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-white"},[_c('p',{staticClass:"text-lg font-semibold"},[_vm._v("ERP Intergration")]),_c('p',{staticClass:"text-sm pt-2"},[_vm._v(" API integration points for real-time, automatic synchronization of payments to the existing financial systems ")])])
}]

export { render, staticRenderFns }